import React from 'react'

const AreaCard = () => {
  return (
    <div>
        
    </div>
  )
}

export default AreaCard